/**
 * Page Loader & Transitions
 * Shows loader until page fully loads, handles smooth page transitions
 */

(function($) {
	'use strict';

	const PageLoader = {
		$loader: null,
		$body: null,
		isLoading: true,

		init: function() {
			this.$body = $('body');
			this.$loader = $('.page-loader');

			// If loader doesn't exist, create it
			if (!this.$loader.length) {
				this.createLoader();
			}

			// Loader already visible by default via CSS
			// Just wait for page to load
			this.waitForPageLoad();

			// Bind internal link clicks for transitions
			this.bindPageTransitions();
		},

		createLoader: function() {
			const loaderHTML = '<div class="page-loader"><div class="loader-spinner"></div></div>';
			this.$body.prepend(loaderHTML);
			this.$loader = $('.page-loader');
		},

		show: function() {
			this.$loader.removeClass('loaded');
			// Target only main and footer, NOT the header
			$('.site-main, .site-footer').addClass('transitioning');
		},

		hide: function() {
			// Remove transition class from content first
			$('.site-main, .site-footer').removeClass('transitioning');
			
			// Then hide loader after a brief moment
			setTimeout(() => {
				this.$loader.addClass('loaded');
				this.isLoading = false;
			}, 100);
		},

	waitForPageLoad: function() {
		// Wait for window load event (all images, styles, scripts)
		$(window).on('load', () => {
			this.hide();
		});

		// Handle browser back/forward navigation (bfcache)
		$(window).on('pageshow', (event) => {
			// If page was loaded from cache, immediately hide loader
			if (event.originalEvent.persisted) {
				this.hide();
			}
		});

		// Fallback timeout if window.load takes too long (max 5 seconds)
		setTimeout(() => {
			if (this.isLoading) {
				console.log('Page loader timeout - forcing hide');
				this.hide();
			}
		}, 5000);
	},

	getEventParentSlug: function(url) {
		// Extract parent event slug from URL
		// e.g., /events/parent-event/child/ -> parent-event
		// e.g., /events/parent-event/ -> parent-event
		const match = url.match(/\/events\/([^\/]+)/);
		return match ? match[1] : null;
	},

	bindPageTransitions: function() {
		// Intercept clicks on internal links
		$(document).on('click', 'a[href]:not([target="_blank"]):not([href^="#"]):not([href^="mailto:"]):not([href^="tel:"])', (e) => {
			const href = e.currentTarget.href;
			const currentDomain = window.location.hostname;
			
			// Check if it's an internal link
			try {
				const linkURL = new URL(href);
				if (linkURL.hostname === currentDomain) {
				// Check for no-transition class or data attribute
				if ($(e.currentTarget).hasClass('no-transition') || $(e.currentTarget).data('no-transition')) {
					return; // Let it navigate normally
				}

				// Skip pagination links (handled by AJAX)
				if ($(e.currentTarget).closest('.archive-pagination').length) {
					return; // Let AJAX handle it
				}

				// Skip transitions only when navigating between subpages of the same parent event
				const currentURL = window.location.href;
				const currentParentSlug = this.getEventParentSlug(currentURL);
				const targetParentSlug = this.getEventParentSlug(linkURL.href);
				
				// Only skip if both are events AND they share the same parent
				if (currentParentSlug && targetParentSlug && currentParentSlug === targetParentSlug) {
					return; // Let it navigate normally without transition (same event, different subpages)
				}

				// Prevent default and show loader
				e.preventDefault();
				this.show();

				// Navigate after brief delay for transition
				setTimeout(() => {
					window.location.href = href;
				}, 300);
				}
			} catch (error) {
				// Invalid URL, let it proceed normally
			}
		});
	}
	};

	// Initialize on document ready
	$(document).ready(function() {
		PageLoader.init();
	});

})(jQuery);

